export namespace FiItemConstants {
    export enum FiItemTxnTypes {
        BASIC_ITEM = 'BASIC_ITEM',
        GROUPED_ITEM = 'GROUPED_ITEM',
        BUNDLE = 'BUNDLE',
        COUPON = 'COUPON',
        SERVICE = 'SERVICE',
        WARRANTY = 'WARRANTY',
        BATCH_EXPIRY = 'BATCH_EXPIRY',
        DOC_HEADER_ADJUSTMENT = 'DOC_HEADER_ADJUSTMENT',
        MARKETPLACE_URL = 'MARKETPLACE_URL',
        MEMBERSHIP = 'MEMBERSHIP',
        DELIVERY_CHARGE = 'DELIVERY_CHARGE',
        MADE_TO_ORDER = 'MADE_TO_ORDER',
        GROUP_DISCOUNT = 'GROUP_DISCOUNT'
    }

    export enum FiItemImageTypes {
        MAIN = 'MAIN',
        PROMOTION = 'PROMOTION',
        ADDITIONAL = 'ADDITIONAL'
    }

    export enum FiItemImportTypes {
        DOC_ITEM = 'DOC_ITEM',
        DOC_ITEM_RELATIONSHIP = 'DOC_ITEM_RELATIONSHIP',
        DOC_ITEM_WITH_COMP_GL_CODE = "DOC_ITEM_WITH_COMP_GL_CODE"
    }

    export enum FiItemImageParamCodes {
        CP_COMMERCE_IMAGE_UPLOADED = 'CP_COMMERCE_IMAGE_UPLOADED'
    }

    export enum FiItemCodeTypes {
        SHIPPING_SERVICE = 'SHIPPING-SERVICE'
    }

    export enum FiItemStatusTypes {
        ACTIVE = 'ACTIVE',
        INACTIVE = 'INACTIVE',
        DELETED = 'DELETED',
    }

    export enum FiItemPricingLogicTypes {
        PARENT = 'PARENT', 
        CHILD = 'CHILD',
    }
}